import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AcademyWelcomeModal.css';

interface Props {
  onDismiss: () => void;
}

/**
 * Modal shown after wizard completion to prompt users to start their Academy training.
 *
 * Conditions under which it renders (all must be true):
 *  - User role is NOT SuperAdmin
 *  - localStorage key `academyDone-{userId}` is not set (academy not yet completed)
 */
const AcademyWelcomeModal: React.FC<Props> = ({ onDismiss }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Guard: do not show for SuperAdmin
  if (user?.role === 'SuperAdmin') return null;

  // Guard: do not show if academy already completed
  if (user?.id && localStorage.getItem(`academyDone-${user.id}`)) return null;

  const handleTakeMe = () => {
    onDismiss();
    navigate('/academy');
  };

  return (
    <div className="awm-overlay" role="dialog" aria-modal="true" aria-labelledby="awm-title">
      <div className="awm-card">
        <div className="awm-icon">🎓</div>
        <h2 className="awm-title" id="awm-title">Your Training is Ready</h2>
        <p className="awm-body">
          To help you get the most out of Myshield, we have put together a short training
          programme tailored to your role. It covers everything you need to know in 5 easy
          modules with a quiz at the end of each.
        </p>
        <div className="awm-actions">
          <button className="awm-btn-primary" onClick={handleTakeMe}>
            Take me to the Academy
          </button>
          <button className="awm-btn-secondary" onClick={onDismiss}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcademyWelcomeModal;
